import { Navigate } from "react-router-dom"
import { routes } from "../routes"
import { useAuth } from "../context/authContext";
import { useEffect, useState } from "react";

interface Props {
    children: React.ReactElement;
}

const ProtectedRoute = (props: Props) => {
    const { verified, refreshToken } = useAuth()
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyUser = async () => {
            await refreshToken();
            setLoading(false);
        };

        if (!verified) {
            verifyUser();
        } else {
            setLoading(false);
        }
    },[verified, refreshToken])


    if (loading) {
        // Return loading indicator or placeholder until verification is complete
        return <></>;
    }

    if (!verified) {
        // If not verified, navigate to the home route
        return <Navigate to={routes.HOME} replace />;
    }

    // If verified, render the children components
    return props.children;
}

export default ProtectedRoute